export default "__VITE_ASSET__XV6s9c_I__"